import Address from "./Address";
import LgoInfos from "./LgoInfos";
import DeprecatedGrouping from "./laboratory/Grouping";
import {Video} from "@/video/interfaces";

export enum EntityTypeID {
    LABORATORY = 1,
    HEALTHCENTER = 2
}

interface Entity {
    id: number;
    name: string;
    lgo: number;
    url?: any;
    cip: string;
    lastLgoImport: string;
    santeSecureVersion: string;
    uga: string;
    finessHealthcenter?: any;
    finessLegal?: any;
    siret?: any;
    siren?: any;
    /**
     * Optional because `HealthcenterTransformer`, which serves this entity on
     * `GET /profile/accesses/current`, does NOT return it — only
     * `HealthcenterHeldTransformer` does. Declared as a plain string, it read
     * as always present and let code build on a field that is never sent.
     *
     * Note it is not a public identifier either: `DeepGuard` accepts it as an
     * authentication bearer, so it must never travel in a URL or a message.
     */
    deepToken?: string;
    active: boolean;
    isGroupingValidated: boolean;
    isTester: boolean;
    address: Address;
    lgoInfos: LgoInfos;
    grouping?: DeprecatedGrouping;
    sponsorshipSponsors?: {
        id: number;
        description: string | null;
        booking_url: string | null;
        booking_description: string | null;
        entityTypeId: EntityTypeID;
        entityId: number;
        entity: { name: string; branding?: { logo?: { renderPath: string } } };
        extensions: {
            id: number;
        }[],
        videos: Video[];
    }[];
}

export default Entity;
